// extracted by mini-css-extract-plugin
export default {"root":"T7ta6","text":"LpPRt","status":"f2pvF","message":"fZH3T","closeIcon":"mjCQd"};